import React from "react";

import Languages from "./Languages";

const TopBar: React.FC = () => {
  return (
    <div>
      <Languages />
    </div>
  );
};

export default TopBar;
